var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinimize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.08609 16.4142L8.02716 20.8371M8.08609 16.4142L3.6632 16.4731M8.08609 16.4142L2.72212 21.7782",
    stroke: "#9DA1AF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.08549 7.58579L3.66261 7.52687M8.08549 7.58579L8.02657 3.16291M8.08549 7.58579L2.72153 2.22183",
    stroke: "#9DA1AF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1823 16.4144L19.6052 16.4733M15.1823 16.4144L15.2412 20.8373M15.1823 16.4144L20.5462 21.7784",
    stroke: "#9DA1AF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1823 8.58598L15.2412 4.1631M15.1823 8.58598L19.6052 8.52706M15.1823 8.58598L20.5462 3.22202",
    stroke: "#9DA1AF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinimize);
export default __webpack_public_path__ + "static/media/minimize.1e22bf1191e18dcd6f945ccd19a6b1f9.svg";
export { ForwardRef as ReactComponent };